import { AxiosResponse } from "axios";
import { AliasViewModel, IdentityUser } from "../aliases/AliasStore";
import axios, { APIWrapperResponse, TypedResponse } from "../general/HttpClient";
import { LeagueViewModel } from "../leagues/LeaguesStore";
import { SeasonViewModel } from "../seasons/SeasonsStore";
import { TeamViewModel } from "../teams/TeamsStore";
import { TournamentViewModel } from "../tournaments/TournamentsStore";

export function getOverallUsage() {
    return axios.get("/api/Billing/getOverallUsage").then((response: AxiosResponse<APIWrapperResponse<TypedResponse<OrganizationUsageDetail[]>>>) => {
        return response.data.result;
    });
}

export function getOrganizationUsage(id) {
    return axios.get("/api/Billing/getOrganizationUsage", { params: { id } }).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<OrganizationUsageDetail>>>) => {
        return response.data.result;
    });
}

export interface OrganizationUsageDetail {
    organizationID: string;
    name: string;
    logoUri: string;
    users: IdentityUser[];
    aliases: AliasViewModel[];
    teams: TeamViewModel[];
    tournaments: TournamentViewModel[];
    leagues: LeagueViewModel[];
    seasons: SeasonViewModel[];
}
